import get from "lodash/get";

const FloodlightActivities = {
  enable() {},
  init() {},
  wait() {
    return !!window.gtag;
  },
  paso1() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om0+standard",
    });
  },
  noCliente() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om00+standard",
    });
  },
  paso3() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om000+standard",
    });
  },
  paso4() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om001+standard",
    });
  },
  paso5() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om002+standard",
    });
  },
  paso6() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om003+standard",
    });
  },
  paso7(context) {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      u7: context.state.simulacion.importe.split("$ ")[1].split(".").join(""),
      u8: context.state.simulacion.moneda,
      send_to: "DC-10031883/pf_co0/pf_om005+standard", //Cambiar
    });
  },
  cliente() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/pf_co0/pf_om006+standard",
    });
  },
  thank(context) {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      u7: context.state.simulacion.importe.split("$ ")[1].split(".").join(""),
      u8: context.state.simulacion.moneda,
      send_to: "DC-10031883/pf_co0/pf_om004+standard",
    });
  },
};

export default FloodlightActivities;
